<template>
  <div class="jin-form-attach">
    <Upload
      title="上传附件"
      tips="支持文档、图片、压缩包、视频、音频、设计文件等格式文件，所有附件大小总和不超过50MB"
      path="annex/"
      show-file-list
      show-list
      accept=""
      :size="50"
      :info="info"
      @change="handleChange"
      @beforeUpload="beforeUpload"
    />
  </div>
</template>

<script>

export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      fileList: [],
      annex: [],
      files: [],
      size: 0
    }
  },
  methods: {
    handleChange(fileList) {
      this.size = fileList && fileList.length ? fileList.map(item => item.file.size).reduce((prev, curr) => prev + curr) : 0
      this.annex = fileList.map(item => {
        return {
          url: item.url,
          type: item.file.name.split('.')[1],
          file: {
            name: item.file.name,
            size: item.file.size
          }
        }
      })
      this.info.files = this.annex
      this.$emit('autoSave')
    },
    beforeUpload(file) {
      const size = this.size / 1024 / 1024 < 50
      if (!size) this.$message.error('上传附件大小总和不能超过50MB')
      return size
    },
    resetForm() {
      this.info.files = []
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-form {
  &-attach {
    &-con {
      padding: 30px 20px;

      span {
        color: #787b8a;
        line-height: 22px;
      }

      .el-button {
        margin-top: 4px;
        width: 320px;
        height: 42px;
        border-color: #dddfe3;
        background: #dddfe3;
        border-radius: 4px;
        font-size: 14px;
        color: #787b8a;
      }

      .el-upload__tip {
        margin-top: 12px;
        color: #a0a4b7;
        line-height: 20px;
        font-size: 14px;
      }
    }
  }
}
</style>
